/* raw layout hash: _live-charging-telemetry-layout:47e404f4d8970161bfde72b8943e75a0fc5e897be5d5929e67542189cac05927 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _live-charging-telemetry-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function LiveChargingTelemetryLayout() {
  return <AppShell />;
}
